
export default [
    {
        path: '/dataList/inventory/inventoryWastage',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '产品出库',
            keepAlive: false
        }
    },
];
  